<template>
    <span class="loader"></span>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.loader {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    border: 10px solid;
    border-color: rgba(63, 63, 63, 0.15) rgba(114, 113, 113, 0.25) rgba(150, 150, 150, 0.35) rgba(229, 227, 227, 0.5);
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
